import { render, staticRenderFns } from "./actionOrderSuppliersRequest.vue?vue&type=template&id=27d8fac1&"
import script from "./actionOrderSuppliersRequest.vue?vue&type=script&lang=js&"
export * from "./actionOrderSuppliersRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports